import apiClient from '@u/apiClient.js'

export default {
  addUnavailabilityItem({ commit, state }, payload) {
    if (state.mutateController) {
      state.mutateController.abort()
      state.mutateController = undefined
    }

    state.mutateLoading = true

    state.mutateController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .post('unavailability/items', payload.data, {
          signal: state.mutateController.signal
        })
        .then((response) => resolve(response.data))
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.mutateLoading = false
        })
    })
  },
  updateUnavailabilityItem({ commit, state }, payload) {
    if (state.mutateController) {
      state.mutateController.abort()
      state.mutateController = undefined
    }

    state.mutateLoading = true

    state.mutateController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .put(`unavailability/items/${payload.id}`, payload.data, {
          signal: state.mutateController.signal
        })
        .then((response) => resolve(response.data))
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.mutateLoading = false
        })
    })
  },
  fetchUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .get('unavailability/items', {
          params: payload,
          signal: state.fetchController.signal
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
          console.error('Error : ', reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  },
  deleteUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`unavailability/items/${payload.id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  },
  undoDeleteUnavailabilityItems({ commit, state }, payload) {
    if (state.fetchController) {
      state.fetchController.abort()
      state.fetchController = undefined
    }
    state.fetchLoading = true
    state.fetchController = new AbortController()
    return new Promise((resolve, reject) => {
      apiClient
        .get(`unavailability/items/${payload.id}/undo-delete`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
        .finally(() => {
          state.fetchLoading = false
        })
    })
  }
}
